import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DisclaimerPage = () => {
  useEffect(() => {
    document.title = "Disclaimer - IP Partners Inc";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-gradient-to-br from-brown-100 to-brown-50 pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 text-brown-700 hover:text-brown-800 font-semibold mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Back to Home</span>
          </Link>
          <h1 className="text-4xl sm:text-5xl font-bold text-brown-900">Disclaimer</h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-brown max-w-none space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">General Information</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                The information provided on this website is for general informational purposes only. It is not intended 
                to provide legal advice or create an attorney-client relationship. The content on this site should not 
                be relied upon as a substitute for consultation with a qualified attorney.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">No Attorney-Client Relationship</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                Your use of this website and the information contained herein does not create an attorney-client 
                relationship between you and IP Partners Inc or any of its attorneys. An attorney-client relationship 
                is only established through a formal engagement agreement signed by both parties.
              </p>
              <p className="text-brown-700 leading-relaxed mb-4">
                Confidential or time-sensitive information should not be sent through this website. If you wish to 
                discuss a legal matter with one of our attorneys, please contact us directly to schedule a consultation.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">No Guarantee of Results</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                Case results and testimonials shared on this website do not guarantee or predict a similar outcome in 
                any future case. Every legal matter is unique and depends on its own facts and circumstances. Past 
                performance is not indicative of future results.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">Accuracy of Information</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                While we strive to provide accurate and up-to-date information, laws and regulations change frequently. 
                IP Partners Inc makes no representations or warranties regarding the accuracy, completeness, or 
                timeliness of the content on this website. We reserve the right to modify or remove any information 
                at any time without notice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">External Links</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                This website may contain links to external websites for your convenience. IP Partners Inc does not 
                endorse or control these external sites and is not responsible for their content, accuracy, or practices. 
                Your use of any external website is at your own risk.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">Limitation of Liability</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                To the fullest extent permitted by law, IP Partners Inc and its attorneys shall not be liable for any 
                damages arising from your use of this website or reliance on the information contained herein. This 
                includes direct, indirect, incidental, consequential, or punitive damages.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">Jurisdiction-Specific Information</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                Legal requirements vary by jurisdiction. The information on this website may not be applicable to your 
                specific situation or jurisdiction. Always consult with a licensed attorney in your area for advice 
                tailored to your circumstances.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-brown-900 mb-4">Contact Information</h2>
              <p className="text-brown-700 leading-relaxed mb-4">
                If you have questions about this disclaimer or need legal assistance, please contact us:
              </p>
              <div className="bg-brown-50 p-6 rounded-lg">
                <p className="text-brown-700 mb-2"><strong>IP Partners Inc</strong></p>
                <p className="text-brown-700 mb-2">1990 N California Blvd, Walnut Creek, CA 94596, United States</p>
                <p className="text-brown-700 mb-2">Phone: +1 (833) 201-7574</p>
                <p className="text-brown-700">Email: info@ippartnerinc.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DisclaimerPage;
